import { createContext, useContext } from "react";

import { type UsedBySubject } from "~/components/usedBy/usedByHelpers";

export interface UsedByPanelContextValue {
	openUsedBy: (subject: UsedBySubject) => void;
}

const UsedByPanelContext = createContext<UsedByPanelContextValue>({ openUsedBy: () => {} });

export const useUsedByPanel = (): UsedByPanelContextValue => useContext(UsedByPanelContext);

export default UsedByPanelContext;
